<!-- The progressbar that is shown above questions -->
<template>
    <div progressbar aria-live="assertive">
        <div data-bar>
            <span
                data-value-label
                :style="{ 
                    width: `${progressPercentage}%`
                }"
            >
                <span data-only-screenreader>{{this.$store.getters.textResource(`rs_progress`)}}</span>
                <p v-if="layout.ProgressBar.ShowProgressTopPublicName === 'WithPercentage'">{{ progressPercentage }}%</p>
            </span>
            <span data-succes-icon>
                <font-awesome-icon icon="check" />
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: `progress-bar`,
    computed: {
        state: function () {
            return this.$store.state;
        },
        progressPercentage: function () {
            let page = this.state.page;
            if (page === undefined) return 0;

            let progress = parseInt(page.progress);

            if (progress < 0) return 0;
            else if (progress > 100 || isNaN(progress)) return 100;
            return progress;
        },
        layout: function () {
            return this.state.layout;
        },
    },
};
</script>

<style scoped>
[progressbar] {
    position: relative;
    border: 1px solid #333;
    height: 25px;
    width: 300px;
    border: 1px solid #ebebeb;
    background: #f8f8f8;
    height: 101px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px 20px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;

    [data-bar] {
        background: #ebebeb;
        border-radius: 50px;
        height: 26px;
        width: 100%;
        display: block;
        position: relative;
    }

    [data-value-label] {
        background: var(--progressbar-color);
        position: absolute;
        left: 0;
        top: -3px;
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        padding: 5px 10px;
        text-align: center;
        transition: 0.5s ease-out;
        min-width: 80px;
        font-size: 18px;
        font-family: var(--page-font-family-public-name);
        color: var(--progresspercentage-color);
        min-height: 33px;

        p {
            margin: 0;
        }
    }

    [data-succes-icon] {
        width: 35px;
        height: 35px;
        background: var(--check-color);
        border-radius: 50%;
        box-shadow: -2px 0 3px #00000040;
        display: flex;
        position: absolute;
        right: -3px;
        top: -5px;
        align-items: center;
        justify-content: center;

        svg {
            color: #fff;
        }
    }
}
</style>